import { skipToken } from "@reduxjs/toolkit/query";
import QueryWrapper from "common/components/QueryWrapper";
import { useEvent } from "event/hooks/useEvent";
import { useGetEventQuery } from "event/api/event.api";

import type { Event } from "event/types/event.model";
import type { Message } from "wall/types/message.model";

import { EventDate } from "event/play/components/EventDate";
import { EVENT_HEADER_FIRST_OPPONENT } from "_constants";

import { UseFormReturnType } from "@mantine/form";

import { ListNavigation } from "./ListNavigation";
import "event/play/common/PronosticView.css";
import "./Header.css";
import { useSavedEvent } from "../../hooks/useSavedEvent";
import {
  DEFAULT_RED_COLOR,
  DEFAULT_WHITE_COLOR,
  DEFAULT_PSG_EVENT_LOGO,
} from "../../../_graphic_design";
import { useEffect, useState } from "react";
import { useMantineTheme } from "@mantine/core";
import { TransperentNavigation } from "./TransperentNavigation";

type PSGHeaderProps = {
  form?: UseFormReturnType<
    Partial<Message>,
    (values: Partial<Message>) => Partial<Message>
  >;
  setIsMessageSent?: React.Dispatch<React.SetStateAction<boolean>>;
};
export function Header({ form, setIsMessageSent }: PSGHeaderProps) {
  const event: Event | undefined = useEvent();
  const getEventQuery = useGetEventQuery(event?.id ?? skipToken);
  const [savedEvent] = useSavedEvent(event?.id!);
  const [isHomePage, setIsHomePage] = useState(false);
  // theme by hook
  const theme = useMantineTheme();
  const isTransperent =
    event?.navigation?.navigationType ===
    ("transparent" as "transperent" | "default");

  // console.log("isTransperent", isTransperent);
  // console.log(event?.navigation?.navigationType);

  //console.log("event", event);

  useEffect(() => {
    const eventHomePage = document.getElementById("EventHomePage");

    if (eventHomePage) {
      setIsHomePage(true);
    }
  }, []);

  if (!event) {
    return <></>;
  }

  return (
    <div className="header" style={{ fontFamily: theme.fontFamily }}>
      <QueryWrapper query={getEventQuery}>
        {(event) => (
          <div
            style={{
              height: "25%",
              width: "100vw",
              maxWidth: "480px",
              maxHeight: "250px",
              paddingTop: "5%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={event.images?.teamLogo ?? DEFAULT_PSG_EVENT_LOGO}
                alt="Logo"
                style={{ width: "24%", zIndex: 0 }}
              />
              <div
                style={{
                  display: "flex",
                  backgroundColor:
                    event.colors?.headerBackground ?? DEFAULT_RED_COLOR,
                  width: "100%",
                  height: "55px",
                  marginLeft: "-4.5%",
                  //marginRight: "3%",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  className="psg-text w-8/12 border-r-2 font-bold"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    color: event.colors?.headerEventText ?? DEFAULT_WHITE_COLOR,
                    textAlign: "start",
                    marginLeft: "8%",
                    marginRight: "2%",
                  }}
                >
                  {event.team_name?.toUpperCase() ??
                    EVENT_HEADER_FIRST_OPPONENT}
                  <p>{event.opponent.name.toUpperCase()}</p>
                </div>
                {event ? <EventDate className="w-4/12" event={event} /> : null}
              </div>
            </div>
          </div>
        )}
      </QueryWrapper>
      {savedEvent && isHomePage && !isTransperent && (
        <ListNavigation
          event={event}
          form={form}
          open={true}
          setIsMessageSent={setIsMessageSent}
        />
      )}
      {savedEvent && isHomePage && isTransperent && (
        <TransperentNavigation
          event={event}
          form={form}
          open={true}
          setIsMessageSent={setIsMessageSent}
        />
      )}
      {savedEvent && !isHomePage && !isTransperent && (
        <ListNavigation
          event={event}
          form={form}
          open={false}
          setIsMessageSent={setIsMessageSent}
        />
      )}
      {savedEvent && !isHomePage && isTransperent && (
        <TransperentNavigation
          event={event}
          form={form}
          open={false}
          setIsMessageSent={setIsMessageSent}
        />
      )}
    </div>
  );
}
